import { useTranslation } from "react-i18next";
import { Search } from "lucide-react";

export function GlobalSearchTriggerMobile({ onOpen }: { onOpen: () => void }) {
  const { t } = useTranslation();
  return (
    <button
      onClick={onOpen}
      className="p-2 rounded-md hover:bg-accent transition-colors"
      aria-label={t("globalSearch.openSearch", "Search")}
      data-testid="global-search-mobile-trigger"
    >
      <Search className="h-5 w-5" />
    </button>
  );
}
